import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { BarChartModule } from 'rev-shared/ui/dataVisualization/barChart/BarChart.Module';
import { ButtonsAngularModule } from 'rev-shared/ui/buttons/ButtonsAngular.Module';
import { DataGridModule } from 'rev-shared/ui/dataGrid/DataGrid.Module';
import { DateAngularModule } from 'rev-shared/date/DateAngular.Module';
import { DialogAngularModule } from 'rev-shared/ui/dialog/DialogAngular.Module';
import { KpiModule } from 'rev-shared/ui/reports/kpi/Kpi.Module';
import { LineChartModule } from 'rev-shared/ui/dataVisualization/lineChart/LineChart.Module';
import { PieChartModule } from 'rev-shared/ui/dataVisualization/pieChart/PieChart.Module';
import { ReportCellModule } from 'rev-shared/ui/reports/reportCell/ReportCell.Module';
import { SearchInputModule } from 'rev-shared/ui/searchInputAngular/SearchInput.Module';
import { SpinnerAngularModule } from 'rev-shared/ui/spinner/SpinnerAngular.Module';
import { TabPanelModule } from 'rev-shared/ui/tabPanel/TabPanel.Module';
import { VbDropdownMenuModule } from 'rev-shared/ui/dropdown-menu/VbDropdownMenu.Module';
import { VbUiDatePickerModule } from 'rev-shared/ui/datePicker/VbUiDatePicker.Module';

import { EventAnalyticsAttendeesChartComponent } from './eventAnalytics/EventAnalyticsAttendeesChart.Component';
import { EventAnalyticsComponent } from './eventAnalytics/EventAnalytics.Component';
import { EventAnalyticsKpisComponent } from './eventAnalytics/EventAnalyticsKpis.Component';
import { EventsGridComponent } from './eventAnalytics/EventsGrid.Component';
import { LiveEventsGridComponent } from './eventAnalytics/LiveEventsGrid.Component';
import { ReportGridWrapperComponent } from './ReportGridWrapper.Component';
import { ReportTabComponent } from './ReportTab.Component';
import { ReportTabContentComponent } from './ReportTabContent.Component';
import { VideoAnalyticsComponent } from './videoAnalytics/VideoAnalytics.Component';
import { VideoReportKpisComponent } from './videoAnalytics/VideoReportKpis.Component';
import { VideosTopHitsGridComponent } from './videoAnalytics/VideosTopHitsGrid.Component';
import { ViewsGridComponent } from './videoAnalytics/ViewsGrid.Component';

const components = [
	EventAnalyticsAttendeesChartComponent,
	EventAnalyticsComponent,
	EventAnalyticsKpisComponent,
	EventsGridComponent,
	LiveEventsGridComponent,
	ReportTabComponent,
	ReportTabContentComponent,
	ReportGridWrapperComponent,
	VideoReportKpisComponent,
	VideoAnalyticsComponent,
	VideosTopHitsGridComponent,
	ViewsGridComponent
];


@NgModule({
	declarations: components,
	exports: components,
	imports: [
		BarChartModule,
		ButtonsAngularModule,
		CommonModule,
		DataGridModule,
		DateAngularModule,
		DialogAngularModule,
		LineChartModule,
		PieChartModule,
		TabPanelModule,
		FormsModule,
		KpiModule,
		ReportCellModule,
		SearchInputModule,
		SpinnerAngularModule,
		TranslateModule,
		VbUiDatePickerModule,
		VbDropdownMenuModule
	]
})
export class AnalyticsModule {}
